import { useEffect, useMemo, useState } from 'react'
import type { Pallet } from '../types/domain'
import { palletStatusLabel } from './format'

interface Props {
  pallets: Pallet[]
  value: string
  onChange: (palletId: string) => void
  disabled?: boolean
  showStatus?: boolean
}

export function PalletSearchSelect({ pallets, value, onChange, disabled, showStatus = true }: Props) {
  const [query, setQuery] = useState('')
  const filtered = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase('ru-RU')
    if (!normalized) return pallets
    return pallets.filter(pallet => [pallet.number, pallet.batchNumber, pallet.cargoType]
      .some(field => field?.toLocaleLowerCase('ru-RU').includes(normalized)))
  }, [pallets, query])

  useEffect(() => {
    if (filtered.length && !filtered.some(pallet => pallet.id === value)) onChange(filtered[0]!.id)
  }, [filtered, onChange, value])

  return (
    <div className="pallet-picker">
      <label className="search-field">
        <span>Поиск паллеты</span>
        <div><i aria-hidden="true">⌕</i><input type="search" value={query}
          onChange={event => setQuery(event.currentTarget.value)}
          placeholder="Номер, партия или тип груза" disabled={disabled} /></div>
      </label>
      <label className="select-field">
        <span>Паллета</span>
        <select value={filtered.some(pallet => pallet.id === value) ? value : ''}
          onChange={event => onChange(event.currentTarget.value)} disabled={disabled || !filtered.length}>
          {!filtered.length && <option value="">Ничего не найдено</option>}
          {filtered.map(pallet => <option key={pallet.id} value={pallet.id}>
            {pallet.number} · {pallet.batchNumber}{showStatus ? ` · ${palletStatusLabel[pallet.status]}` : ''}
          </option>)}
        </select>
      </label>
    </div>
  )
}
